import React, { Component } from 'react';

export default class Window extends Component {
  constructor(props) {
    super(props);
    this.state = {
      speed: 10, //飘动速度，即为定时器函数多长时间执行一次
      statusX: 1, //规定每执行一次函数，left属性值变化的幅度,用来判断x是否到头
      statusY: 1, //规定每执行一次函数，top属性值变化的幅度，用来判断y是否到头
      offsetX: Number(props.pcData.zcjl), //该飘窗的x轴偏移位置(初始位置--左侧距离)
      offsetY: Number(props.pcData.dbjl), //该飘窗的y轴偏移位置(初始位置--顶部距离)
      CloseBtn: true, //关闭按钮是否显示
      widowVisible: false, //控制飘窗是否关闭
      imgWidth: Number(props.pcData.kd), //飘窗图片的宽度
      imgHeight: Number(props.pcData.gd), //飘窗图片的高度
      pcsfkgb: props.pcData.pcsfkgb, //是否有关闭飘窗地功能（关闭按钮是否需要,1:需要，0:不需要）
      btsfxs: props.pcData.btsfxs, //飘窗标题是否显示
      tpbt: props.pcData.tpbt, //图片标题
      documentElementScrollHeight: 0  //保存固定的页面总高度，防止给飘窗设置定位引起获取的页面总高度变化问题
    };
  }
  componentDidMount() {
    setTimeout(() => {
      // 使用定时器避免其他组件未挂在完导致获取的页面高度偏小问题
      this.setState({documentElementScrollHeight:document.documentElement.scrollHeight})
    }, 500);
    // 定时器
    this.interval = setInterval(() => {
      this.ggRollGO();
    }, this.state.speed);
  }

  moveOut = () => {
    // console.log("移出");
    this.setState({ CloseBtn: true }, () => {
      this.interval = setInterval(() => {
        this.ggRollGO();
      }, this.state.speed);
    });
  };

  moveOver = () => {
    // console.log("移入");
    this.setState({ CloseBtn: false }, () => {
      clearInterval(this.interval);
    });
  };

  ggRollGO = () => {
    const { speed, statusX, statusY, offsetX, offsetY, imgWidth, imgHeight, documentElementScrollHeight } = this.state;
    let roll = document.getElementById('roll'); //获取飘窗属性
    //  //差值用来测算left属性值的极限
    let winW = document.documentElement.clientWidth - imgWidth - 10;
    let winH = documentElementScrollHeight - imgHeight;
    //如果statusX=1则每次减少1px,否则增加1px
    let newX = offsetX + (statusX == 1 ? -1 : 1);
    //如果left属性值小于0，也就是div要超出左边界了，就将statusX设置为0
    if (newX < 0) {
      this.setState({
        statusX: 0,
      });
    } else if (newX > winW - 50) {
      this.setState({
        statusX: 1,
      });
    }

    let newY = offsetY + (statusY == 1 ? -1 : 1);
    if (newY < 0) {
      this.setState({
        statusY: 0,
      });
    } else if (newY > winH) {
      this.setState({
        statusY: 1,
      });
    }
    this.setState({
      offsetX: newX,
      offsetY: newY,
    });
  };

  // 点击跳转
  jump = () => {
    const { pcData } = this.props;
    if (pcData.ljdz.indexOf('http') != -1) {
      window.open(pcData.ljdz)
    } else {
      window.open('http://' + pcData.ljdz, '_blank')
    }
  };

  // 关闭飘窗
  closeWindows = () => {
    this.setState({
      widowVisible: true,
    });
    // 并且清除定时器
    clearInterval(this.interval);
  };

  render() {
    const { offsetX, offsetY, CloseBtn, widowVisible, pcsfkgb, imgWidth, imgHeight, btsfxs } = this.state;
    const { pcData } = this.props;
    return (
      /* 实现飘窗效果 */
      <div
        id="roll"
        style={{
          position: 'absolute',
          top: offsetY,
          left: offsetX,
          zIndex: '999',
          display: widowVisible ? 'none' : '',
        }}
        onMouseOver={() => {
          this.moveOver();
        }}
        onMouseOut={() => {
          this.moveOut();
        }}
      >
        {pcsfkgb == '1' && (
          <div
            style={{
              color: '#5e6868',
              position: 'absolute',
              top: '0px',
              right: '-5px',
              display: CloseBtn ? 'none' : '',
              cursor: 'pointer',
            }}
            onClick={() => {
              this.closeWindows();
            }}
          >
            关闭
          </div>
        )}
        <img
          alt={pcData.tpbt}
          src={`zuul/docrepo/download/file?attachmentId=${pcData.tpdz}`}
          onClick={() => {
            this.jump();
          }}
          style={{ width: imgWidth, height: imgHeight, cursor: 'pointer', margin: '20px 20px 0 20px' }}
        />
        {
          btsfxs == '1' && (
            <div style={{width: imgWidth, margin: '5px 20px 0 20px', textAlign: 'center', fontWeight: 'bold'}} >
              {this.state.tpbt}
            </div>
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/index/window.js